import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
export const GeneralEmptyState = t0 => {
  const $ = _c(10);
  const {
    title,
    description,
    button
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      marginY: "40px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <Typography variant="h3" align="center">{title}</Typography>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      maxWidth: "540px"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== description) {
    t4 = <Typography variant="subtitle2" align="center" sx={t3}>{description}</Typography>;
    $[4] = description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== button || $[7] !== t2 || $[8] !== t4) {
    t5 = <Stack spacing="24px" sx={t1}>{t2}{t4}{button}</Stack>;
    $[6] = button;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};